import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children, className = "" }) => (
    <p
        className={`text-xs tracking-[0.25em] uppercase font-semibold text-sage ${className}`}
    >
        {children}
    </p>
);
